import type { AreaFeeService } from '@/utils/fee-maths';

export const defaultMonthlyRentPence = 200_000;

const serviceLabels: Record<AreaFeeService, string> = {
  management: 'full management',
  rentCollection: 'rent collection',
  letOnly: 'let only',
};

const serviceSwitchLabels: Record<
  AreaFeeService,
  { desktop: string; mobile: string }
> = {
  management: { desktop: 'Full management', mobile: 'Full mgmt' },
  rentCollection: { desktop: 'Rent collection', mobile: 'Rent collection' },
  letOnly: { desktop: 'Let only', mobile: 'Let only' },
};

export const directoryFeeServiceLabels = serviceSwitchLabels;

export function formatServiceLabelLowercase(service: AreaFeeService): string {
  return serviceLabels[service];
}

export function formatFeePercent(percentIncVat: number): string {
  const rounded =
    Math.round(percentIncVat * 10) / 10 === Math.round(percentIncVat)
      ? Math.round(percentIncVat).toString()
      : (Math.round(percentIncVat * 10) / 10).toString();

  return `${rounded}%`;
}

export function formatPounds(amountPence: number): string {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: 0,
  }).format(amountPence / 100);
}

export function formatMonthlyRentPounds(monthlyRentPence: number): string {
  return String(Math.round(monthlyRentPence / 100));
}

export function formatSignedPounds(differencePence: number): string {
  const formatted = formatPounds(Math.abs(differencePence));

  if (differencePence === 0) {
    return formatted;
  }

  if (differencePence > 0) {
    return `+${formatted}`;
  }

  return `−${formatted}`;
}

export function parseMonthlyRentInput(rawValue: string): number | null {
  const nextValue = rawValue.replace(/\D/g, '').replace(/^0+/, '').slice(0, 6);

  if (nextValue === '') {
    return null;
  }

  return Number(nextValue) * 100;
}
